<script lang="ts" setup>
import type { GetAllParams, IntelligenceCompany } from '~/composables/api/intelligence/companies/useFetchIntelligenceCompanies'

const emit = defineEmits<{
  companySelected: [company: IntelligenceCompany]
}>()

const { country } = useAuth()

const query = defineModel<string>({ required: true })

const queryWithDebounce = refDebounced(query)

const queryParams = computed<GetAllParams>(() => ({
  query: queryWithDebounce.value,
  country: country.value!,
}))

const {
  data,
  isPending,
} = useQueryIntelligenceCompanies.getAll({
  params: queryParams,
  useQueryOptions: {
    enabled: () => !!queryWithDebounce.value && queryWithDebounce.value.length >= 3,
  },
})
</script>

<template>
  <DTFieldCombobox
    v-model="query"
    @update:selection="(selection) => emit('companySelected', selection as IntelligenceCompany)"
  >
    <DTFieldComboboxOptions v-if="!isPending && data?.length">
      <DTFieldComboboxOption
        v-for="company in data"
        :key="company.ident"
        :value="company"
      >
        <span class="text-sm">
          {{ company.title }}
        </span>
      </DTFieldComboboxOption>
    </DTFieldComboboxOptions>
  </DTFieldCombobox>
</template>
